import request from "@/utils/request";

export default function changeState(id,state) {
    return request({
        url: `/storeShop/agency/changeState/`+id+`/`+state,
        method: 'get',
    })
}
